import axios from 'axios'
import vm from '~/main'

const defaultState = {
  user: '',
  noFirstLogin: '' || localStorage.getItem('NoFirstLogin'),
  userEmployeeData: null,
  userEmployeeDocGrid: null,
  userBaned: false,
  userRoleAbilities: undefined,
  userType: undefined,
  onlineUserData: null,
}

export default {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations: {
    setUserData(state, user) {
      state.user = user
    },
    firstLoginData(state) {
      state.noFirstLogin = false
    },
    setUserBaned(state) {
      state.userBaned = true
    },
    setUserType(state, payload) {
      state.userType = payload
    },
    setUserRoleAbilities(state, payload) {
      state.userRoleAbilities = payload
    },
    setUserUnBaned(state) {
      state.userBaned = false
    },
    noFirstLoginData(state) {
      state.noFirstLogin = true
    },
    getUserEmployeeData(state, payload) {
      state.userEmployeeData = payload
    },
    getUserEmployeeDocGrid(state, payload) {
      state.userEmployeeDocGrid = payload
    },
    setOnlineUserData(state, payload) {
      state.onlineUserData = payload
    },
    RESET_STATE(state) {
      Object.assign(state, defaultState)
    },
  },
  getters: {
    userData: (state) => state.user,
    checkUser: (state) =>
      !!state.user.email &&
      !!state.user.first_name &&
      !!state.user.last_name &&
      (!!state.user.phone || state.user.phone[0] == null),
    noFirstLogin: (state) => !!state.noFirstLogin,
    userEmployeeData: (state) => state.userEmployeeData,
    userEmployeeDocGrid: (state) => state.userEmployeeDocGrid,
    userRoleAbilities: (state) => state.userRoleAbilities,
    userType: (state) => state.userType,
    userBaned: (state) => state.userBaned,
    onlineUserData: (state) => {
      return state.onlineUserData
    },
  },
  actions: {
    getUser({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          // url: rootState.apiDomain + '/api/online/user/data',
          url: rootState.apiDomain + '/api/admin/common/user/current',
          method: 'GET',
        })
          .then((resp) => {
            const user = resp.data.data
            if (
              user.email &&
              user.first_name &&
              user.last_name &&
              user.phone !== null &&
              user.phone[0] !== null
            ) {
              localStorage.setItem('NoFirstLogin', true)
              commit('noFirstLoginData')
            } else {
              localStorage.setItem('NoFirstLogin', false)
              commit('firstLoginData')
            }
            commit('setUserData', user)
            commit('setUserRoleAbilities', user.abilities)
            commit('setUserType', user.type === null ? 'user' : user.type)
            resolve(resp)
          })
          .catch((err) => {
            if (err && err.response.data === 'Sorry, but your account has been blocked.') {
              commit('setUserBaned')
            }
          })
      })
    },
    updateUser({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/user/data',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            const user = resp.data.data
            if (user.email && user.first_name && user.last_name && user.phone) {
              localStorage.setItem('NoFirstLogin', true)
              commit('noFirstLoginData')
            }
            commit('setUserData', user)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    CHANGE_userLanguage({ rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/user/language',
          data: { language_id: vm.$cookies.get('languageSelect').id },
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserEmployeeData({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/employee',
          data: data,
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
            commit('getUserEmployeeData', resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserUpdateEmployeeData({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/employee',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserEmployeeDocGrid({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/employee/doc/grid',
          method: 'GET',
        })
          .then((resp) => {
            commit('getUserEmployeeDocGrid', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserCreateEmployeeDoc({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/employee/doc',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserUpdateEmployeeDoc({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/employee/doc',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUserUpdateWorkRole({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/user/work_role',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onGetOnlineUserData({ commit, rootState }) {
      commit('setOnlineUserData', {})
      let url = rootState.apiDomain + '/api/online/user/data'
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setOnlineUserData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onPutOnlineUserDataSettings({ commit, rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/user/settings',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            console.log('err', err)
            reject(err)
          })
      })
    },
    resetState({ commit }) {
      commit('RESET_STATE')
    },
  },
}
